'use client'

import * as React from 'react'
import * as TabsPrimitive from '@radix-ui/react-tabs'

import { cn } from '@/utils'

function Tabs({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Root>) {
  return (
    <TabsPrimitive.Root
      data-slot="tabs"
      className={cn('flex flex-col bg-tertiary', className)}
      {...props}
    />
  )
}

function TabsList({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.List>) {
  return (
    <TabsPrimitive.List
      data-slot="tabs-list"
      className={cn(
        'pt-1.5 px-6 w-full overflow-y-hidden flex flex-nowrap bg-quaternary',
        className
      )}
      {...props}
    />
  )
}

function TabsTrigger({
  className,
  children,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Trigger>) {
  return (
    <TabsPrimitive.Trigger
      data-slot="tabs-trigger"
      className={cn(
        'relative bg-transparent p-2.5 pl-3 pr-4 border-none rounded-md rounded-b-none cursor-pointer block text-nowrap',
        'data-[state=active]:bg-white',
        'group',
        className
      )}
      {...props}
    >
      <div
        className={cn(
          'hidden group-data-[state=active]:block size-2 overflow-hidden absolute bottom-0 -left-2',
          'before:content-[""] before:block before:absolute before:bottom-0 before:right-0 before:size-[200%] before:rounded-full before:shadow-[4px_4px_0_0_white] before:overflow-hidden'
        )}
      />
      {children}
      <div
        className={cn(
          'hidden group-data-[state=active]:block size-2 overflow-hidden absolute bottom-0 -right-2',
          'before:content-[""] before:block before:absolute before:bottom-0 before:left-0 before:size-[200%] before:rounded-full before:shadow-[-4px_4px_0_0_white] before:overflow-hidden'
        )}
      />
    </TabsPrimitive.Trigger>
  )
}

function TabsContent({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Content>) {
  return (
    <TabsPrimitive.Content
      data-slot="tabs-content"
      className={cn(
        'outline-none flex-[1_1_auto] data-[state=inactive]:hidden',
        className
      )}
      {...props}
    />
  )
}

export { Tabs, TabsContent, TabsList, TabsTrigger }
